var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.pageActionConfig, page: _vm.pageConfig }
      }),
      _vm.showLoadProcess
        ? _c("create-process", {
            attrs: {
              "academic-years": _vm.academicYearsToCurrent,
              services: _vm.services
            },
            on: {
              "on-cancel": _vm.onCancelHandler,
              "on-save": _vm.onSaveHandler
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "bg-secondary-3 rounded p-3 searchbar-custom" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 d-flex d-md-flex d-sm-block" },
              [
                _c("custom-drop-down", {
                  staticClass: "w-72",
                  attrs: {
                    clearable: false,
                    fieldkey: "id",
                    fieldname: "name",
                    options: _vm.academicYears,
                    placeholder: "Seleccione Año Académico"
                  },
                  model: {
                    value: _vm.selectedAcademicYear,
                    callback: function($$v) {
                      _vm.selectedAcademicYear = $$v
                    },
                    expression: "selectedAcademicYear"
                  }
                }),
                _c(
                  "action-button",
                  {
                    attrs: { i: "fa fa-search", variant: "success ml-3 px-n5" },
                    on: { click: _vm.onSearchHandler }
                  },
                  [_vm._v(" Buscar ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm.hasResults
        ? _c("separator", {
            staticClass: "my-3 p-0",
            attrs: { text: "Resultado de Proceso de Carga" }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(result) {
        return _c("row", {
          key: result.batchLoadControlId,
          attrs: { process: result },
          on: { "on-update": _vm.onUpdateProcess }
        })
      }),
      _vm.results.length > 0
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: { "pagination-go-page": _vm.pageChanged }
          })
        : _vm._e(),
      _vm.hasSearched && !_vm.hasResults
        ? _c("b-col", { attrs: { md: "12" } }, [
            _c("div", { staticClass: "alert alert-warning mt-5" }, [
              _vm._v(
                " No existen datos a ser actualizados en la corrida seleccionada. "
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }